import { useTranslation } from "react-i18next";
import { CompanySize } from "../../interfaces";
import { COMPANY_INDUSTRY_OPTIONS, COMPANY_SIZE_OPTIONS, WHY_PORTANT_OPTIONS } from "../../utils";
import SelectField from "../SelectField";
import TextInputField from "../TextInputField";

export type OnboardingAnswers = {
  companyName: string;
  companySize: CompanySize;
  companyIndustry: string;
  heardAboutFrom: string;
};

export const BLANK_ANSWERS: OnboardingAnswers = {
  companyName: "",
  companySize: "",
  companyIndustry: "",
  heardAboutFrom: "",
};

interface Props {
  answers: OnboardingAnswers;
  onChange: (answers: OnboardingAnswers) => void;
}

function OnboardingQuestions({ answers, onChange }: Props) {
  const { t } = useTranslation();

  const selects = [
    { key: "companySize", label: t("How big is your organisation"), options: COMPANY_SIZE_OPTIONS },
    { key: "companyIndustry", label: t("What industry are you in?"), options: COMPANY_INDUSTRY_OPTIONS },
    { key: "heardAboutFrom", label: t("What brings you to Portant?"), options: WHY_PORTANT_OPTIONS },
  ] as const;
  const answeredInOrder = [answers.companyName.trim(), answers.companySize, answers.companyIndustry];
  const visibleSelects = selects.filter((_, i) => answeredInOrder.slice(0, i + 1).every(Boolean));

  return (
    <div className="flex flex-col gap-4 w-full">
      <div>
        <label className="font-gilroy font-semibold text-gray-600 text-sm mb-1 block">{t("What's your company name?")}</label>
        <TextInputField
          className="w-full !h-10 text-sm"
          value={answers.companyName}
          onChange={(companyName) => onChange({ ...answers, companyName })}
          placeholder={t("Ex. ACME Corp")}
        />
      </div>

      {visibleSelects.map(({ key, label, options }) => (
        <div key={key}>
          <label className="font-gilroy font-semibold text-gray-600 text-sm mb-1 block">{label}</label>
          <SelectField
            className="w-full cursor-pointer !h-10 text-sm"
            value={answers[key]}
            onChange={(value) => onChange({ ...answers, [key]: value } as OnboardingAnswers)}
          >
            <option disabled value="">{t("Select an option")}</option>
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </SelectField>
        </div>
      ))}
    </div>
  );
}

export default OnboardingQuestions;
